(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (e) => {
    const btn = e.target.closest('.compre-agora-button');
    if (!btn) return;

    e.preventDefault();

    // Encontra o formulario nativo de compra (o mesmo do "Adicionar ao carrinho")
    const form = btn.closest('form[data-type="add-to-cart-form"]') || btn.closest('form');
    if (!form) {
      console.error('Formulario de compra nao encontrado.');
      return;
    }

    // Submete o form nativamente, para que o script da Yampi
    // intercepte o evento e redirecione para o checkout da Yampi
    // (em vez de fazer fetch + redirect manual para /checkout).
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
